export type ErrorRecord = { content?: Record<string, unknown> } | {};
interface IInitialVersionState {
  currentVersion: number | undefined;
  draftForm: Record<string, unknown> | null;
  lastVersion: number | undefined;
  initialForm: Record<string, unknown> | null;
  errors: ErrorRecord;
  wasLive: boolean | undefined;
  ui: {
    isDialogOpen: boolean;
    dialogMode: 'create' | 'copy' | 'view' | null;
    dialogTitle: string | null;
  };

  isPromotedOnLive: boolean;
  shouldOpenPromotions: boolean;
  retrieveSaving: boolean;
}
export const initialVersionState: IInitialVersionState = {
  currentVersion: undefined,
  draftForm: null,
  lastVersion: undefined,
  initialForm: null,
  errors: {},
  wasLive: false,
  ui: {
    isDialogOpen: false,
    dialogMode: null,
    dialogTitle: null,
  },
  isPromotedOnLive: false,
  shouldOpenPromotions: false,
  retrieveSaving: true,
};
